import { useEffect, useRef } from 'react'
import debounce from 'lodash/debounce'
import { useEditorState } from 'common/Prose/EditorProvider/hooks/useEditorState'

export const useDebouncedContentAnalysis = (analyze: () => void, delay = 500) => {
  const state = useEditorState()
  const content = state.doc.content
  const prevContentRef = useRef<string | null>(null)
  const debouncedAnalyze = useRef(debounce(analyze, delay)).current

  useEffect(() => {
    const serializedContent = JSON.stringify(content.toJSON())
    if (prevContentRef.current !== serializedContent) {
      prevContentRef.current = serializedContent
      debouncedAnalyze()
    }
  }, [content, debouncedAnalyze])

  useEffect(() => {
    return () => {
      debouncedAnalyze.cancel()
    }
  }, [debouncedAnalyze])
}
